module.exports = __webpack_public_path__ + "static/img/safeProductionTab.069e796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/safeProductionTab.jpg
// module id = Bn+0
// module chunks = 4